'use client';

import { useMemo, useState } from 'react';

export default function Sidebar({ accounts, edgeCounts, onSelect, selectedUsername, showBlocked, onToggleBlocked }) {
  const [filter, setFilter] = useState('all'); // all | t1 | t2 | promoted | blocked
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    return accounts.filter(a => {
      if (filter === 't1' && a.tier !== 1) return false;
      if (filter === 't2' && a.tier !== 2) return false;
      if (filter === 'promoted' && !a.promoted) return false;
      if (filter === 'blocked' && !a.blocked) return false;
      if (q && !a.username.toLowerCase().includes(q.toLowerCase())
           && !(a.display_name || '').toLowerCase().includes(q.toLowerCase())) return false;
      return true;
    });
  }, [accounts, filter, q]);

  return (
    <aside className="w-80 shrink-0 border-r border-graviome-border bg-graviome-panel flex flex-col h-full">
      <div className="p-4 border-b border-graviome-border">
        <h2 className="text-sm uppercase tracking-widest text-graviome-muted mb-2">Accounts</h2>
        <input
          type="search"
          placeholder="search username"
          value={q}
          onChange={e => setQ(e.target.value)}
          className="w-full bg-graviome-bg border border-graviome-border rounded px-3 py-1.5 text-sm font-mono text-graviome-fg placeholder:text-graviome-muted focus:outline-none focus:border-graviome-blue"
        />
        <div className="flex flex-wrap gap-1 mt-2 text-xs">
          {[
            ['all', 'all'],
            ['t1', 'tier 1'],
            ['t2', 'tier 2'],
            ['promoted', 'promoted'],
            ...(showBlocked ? [['blocked', 'duopoly']] : []),
          ].map(([k, label]) => (
            <button
              key={k}
              onClick={() => setFilter(k)}
              className={`px-2 py-1 rounded border ${
                filter === k
                  ? 'bg-graviome-blue/20 border-graviome-blue text-graviome-blue'
                  : 'border-graviome-border text-graviome-muted hover:text-graviome-fg'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
        <label className="flex items-center gap-2 mt-2 text-[11px] text-graviome-muted cursor-pointer select-none">
          <input
            type="checkbox"
            checked={showBlocked}
            onChange={onToggleBlocked}
            className="accent-graviome-amber"
          />
          show duopoly accounts
        </label>
        <div className="text-xs text-graviome-muted mt-2 font-mono">{filtered.length} / {accounts.length}</div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {filtered.map(a => {
          const badgeColor =
            a.tier === 1 && a.promoted ? 'bg-graviome-amber/20 text-graviome-amber' :
            a.tier === 1 ? 'bg-graviome-blue/20 text-graviome-blue' :
            'bg-graviome-grey/30 text-graviome-muted';
          const badgeText = a.tier === 1 && a.promoted ? 'PROMOTED' : a.tier === 1 ? 'T1' : 'T2';
          const edges = edgeCounts?.[a.username] || 0;
          return (
            <button
              key={a.username}
              onClick={() => onSelect?.(a.username)}
              className={`group w-full text-left block px-4 py-2 border-b border-graviome-border/50 hover:bg-graviome-bg-2 transition ${selectedUsername === a.username ? 'bg-graviome-bg-2' : ''}`}
            >
              <div className="flex items-center gap-2">
                <span className={`text-[10px] px-1.5 py-0.5 rounded font-mono ${badgeColor}`}>{badgeText}</span>
                <span className="text-sm truncate flex-1">{a.display_name || a.username}</span>
              </div>
              <div className="text-xs text-graviome-muted font-mono mt-0.5 flex justify-between">
                <span>@{a.username}</span>
                <span>{edges} edges</span>
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
